וצ$w("#gallery1").hide();
                  $w("#gallery2").hide();
         $w("#gallery3").hide();
         $w("#gallery4").hide();// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});